/* eslint-disable react/no-danger-with-children */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useDispatch, useSelector } from 'react-redux';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import LawMenu from 'components/atoms/law_menu';
import { law } from 'store/modules/juridico_facil_store/actions';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';
import Loader from 'components/atoms/loader';
import OpenTutorial from 'components/atoms/open_tutorial';

interface LegislationLawProps {
  params: {
    id?: string;
  };
}

const LegislationLaw = (props: LegislationLawProps) => {
  const { params } = props;
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    params?.id && dispatch(law(params?.id));
  }, []);

  const { juridico, request } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );
  return (
    <div className="page-container p-4">
      {profile.paralyzed ? (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-md-flex d-block align-items-center mb-3">
                <h4 className="mb-1 mr-3 font-weight-bold">Jurídico Fácil</h4>
                <OpenTutorial type="modal" source="juridico" />
              </div>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/juridico">Inicio</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/legislacao">Leis</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Lei
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <LawMenu />
            </div>
            <div className="col-sm-9">
              <div className="card tour-legislation-card">
                <div className="card-body">
                  {request?.law?.loading ? (
                    <Loader />
                  ) : (
                    <>
                      <h4 className="text-uppercase font-weight-bold">
                        {juridico?.leis[0]?.citacao.replace(/(BRASIL\.|\(|\))/g, '')}
                      </h4>
                      <p className="mb-3">{juridico?.leis[0]?.ementa}</p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: juridico?.leis[0]?.conteudo,
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default LegislationLaw;
